module.exports = __webpack_public_path__ + "img/gameshow3.19d11133.svg";